import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import constants from './constants.js';
import { setInterval } from 'timers';
import Web3 from 'web3';
import {Button, PageHeader, ModalBody} from 'react-bootstrap';
import { PropagateLoader } from 'react-spinners';


class SellButton extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tokenValue: 0,
      transaction: null,
      error: null,
      loading: false,
      tokenValueTooHigh: false
    };
    this.sellPonzi = this.sellPonzi.bind(this);
    this.reset = this.reset.bind(this);
  }

  sellPonzi() {
    if (this.state.tokenValue > this.props.balance) {
      this.setState({tokenValueTooHigh: true});
    } else {
      this.setState({loading: true});
      this.props.contractInstance.withdraw(this.state.tokenValue * constants.decimals, (error, result) => {
        this.setState({transaction: result, loading: false, error: error});
      });
    }

  }

  reset() {
    this.setState({loading: false, ethValue: 0, transaction: null, error: null, tokenValueTooHigh: false});
  }

  render() {
    var inputClassName = "form-control";
    var errorDiv = null;
    if (this.state.tokenValueTooHigh) {
      inputClassName += " is-invalid";
      errorDiv = <div style={{color: '#c4183c'}}>Tokens to sell exceeds current balance</div>;
    }
    var mBody = 
    <div>
    <div className="modal-body">
      <p>You currently own <b>{this.props.balance}</b> PonziCoins. The current sell price is <b>{this.props.price}</b> ETH</p>
      <p>As long as the contract still has ETH available, this price is guaranteed, you will get {this.props.price} ETH (or more) per PonziCoin</p>
      <label htmlFor="eth-value" className="col-form-label">Number of Tokens to Sell</label>
      <div><input type="number" id="eth-value" value={this.state.tokenValue} className={inputClassName} placeholder="(e.g. 0.5)" onChange={(event) => {this.setState({tokenValue: event.target.value});}} style={{width: '75%', float: 'left'}} />
      <button type="button" className="btn btn-primary" onClick={() => {this.setState({tokenValue: this.props.balance});}}> 100% </button></div>
      <br/>
      {errorDiv}

      <p>You will get approximately <b>{(this.props.price * this.state.tokenValue).toFixed(3)}</b> ETH</p>
    </div>
    <div className="modal-footer">
      <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.reset}>Nope</button>
      <button type="button" className="btn btn-primary" onClick={this.sellPonzi}>Yep</button>
    </div>
    </div>;

    if (this.state.loading) {
      mBody =<div className="modal-body">
        Confirm the transaction on MetaMask!
      <div style={{margin: 'auto', width: 0, padding: 20}}>
      <PropagateLoader
          color={'#1888ff'} 
          loading={true} 
        />
      </div>
      <div className="modal-footer">
      <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.reset}>Cancel</button>
    </div>
  </div>;
        
    }

    if (this.state.error) {
      <div>
      <div className="modal-body">
        There was an error with the transaction :(

      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.reset}>Close</button>

        <button type="button" className="btn btn-primary" onClick={this.reset}>Try Again</button>
      </div>
      </div>;  
    }
    if (this.state.transaction) {
      mBody = <div>
      <div className="modal-body">
        You're cashing out!
        <br />
        <a target="_blank" href={"https://etherscan.io/tx/" + this.state.transaction}>View the transaction on Etherscan</a>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={this.reset}>OK</button>
      </div>
      </div>; 
    }
    
    return (
      <div>
        <button type="button" className="btn btn-secondary" data-toggle="modal" data-target="#sellModal" onClick={this.reset} disabled>
          Sell PonziCoins
        </button>

       
      </div>
    );
  }
}

export default SellButton;



// WEBPACK FOOTER //
// ./src/SellButton.js